import "./Footer.css";

import Disclaimer from "../../assets/pdfs/disclaimer.pdf";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OnlineBillPayments from "../../assets/pdfs/online-bill-payment-terms.pdf";
import PAIA from "../../assets/pdfs/paia.pdf";
import PayatLogo from "../../assets/images/Pay@.svg";
import PrivacyPolicy from "../../assets/pdfs/privacy-notice.pdf";
import ProcessingPolicy from "../../assets/pdfs/processing-policy.pdf";
import TermsAndConditions from "../../assets/pdfs/terms-and-conditions.pdf";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  return (
    <div className="footer-container">
      <img src={PayatLogo} alt="" />
      <div className="footer-content">
        <div className="footer-links">
          <div className="bold-links">
            <a className="faq-link" href="/faq">
              Frequently Asked Questions
            </a>
            <a className="payment-options-link" href="/about">
              About
              <FontAwesomeIcon
                icon={faArrowRight}
                size="1x"
                color="white"
                style={{ marginLeft: 10, marginBottom: -1 }}
              />
            </a>
          </div>
          <a target="_blank" href="https://payat.co.za/">
            Pay@ Website{" "}
          </a>
          <p className="footer-link-divider">|</p>
          <a target="_blank" href={TermsAndConditions}>
            T&C’s
          </a>
          <p className="footer-link-divider">|</p>
          <a target="_blank" href={PrivacyPolicy}>
            Privacy
          </a>
          {window.innerWidth > 480 ? (
            <p className="footer-link-divider">|</p>
          ) : null}

          <a target="_blank" href={ProcessingPolicy}>
            Processing Policy
          </a>
          <p className="footer-link-divider">|</p>
          <a target="_blank" href={PAIA}>
            PAIA{" "}
          </a>
          {/* <a target="_blank" href="">| Service Terms </a> */}
          <p className="footer-link-divider">|</p>
          <a target="_blank" href={Disclaimer}>
            Disclaimer
          </a>
          {window.innerWidth > 480 ? (
            <p className="footer-link-divider">|</p>
          ) : null}
          <a target="_blank" href={OnlineBillPayments}>
            Online bill payments
          </a>
        </div>
        <div className="coct-contact">
          {window.innerWidth > 480 ? <p>Contact COCT -</p> : null}
          <a href="tel:0860 103 089">
            {window.innerWidth <= 480 && "Telephone (24/7):"} 0860 103 089{" "}
            {window.innerWidth > 480 && "|"}
          </a>
          <a href="mailto:traffic.representation@capetown.gov.za">
            {window.innerWidth <= 480 && "Email:"}{" "}
            traffic.representation@capetown.gov.za
          </a>
        </div>
        {window.innerWidth <= 480 && <div className="footer-divider" />}
        <div className="legal-notices">
          <p>Copyright © 2022 Pay At Services (Pty Ltd) All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
